import CopyableText from './CopyableText';

export default CopyableText;
